export const TYPE={//分账方类型
1:'固定金额',
2:'每月固定的某一天',

}


